import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Document, Page, pdfjs } from "react-pdf";
import resume from "../images/resume.pdf";
import ReactGA from "react-ga4";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function Resume() {
    useEffect(() => {
        document.title = "Resume - DavidAdkins.com";
        if (process.env.NODE_ENV !== "test") {
            ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
        }
    });

    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setPageNumber(1);
    }

    function changePage(offset) {
        setPageNumber(prev => prev + offset);
    }

    return (
        <Grid container direction="column" alignItems="center">
            <Grid item>
                <Typography variant="h6">
                    <Button disabled={pageNumber <= 1} onClick={() => changePage(-1)}>
                        <ArrowBackIosIcon />
                    </Button>
                    {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}
                    <Button disabled={pageNumber >= numPages} onClick={() => changePage(1)}>
                        <ArrowForwardIosIcon />
                    </Button>
                </Typography>
            </Grid>
            <Document
                file={resume}
                onLoadSuccess={onDocumentLoadSuccess}
                loading="Loading..."
                error="Error loading resume."
            >
                <Page pageNumber={pageNumber} renderTextLayer={false} renderAnnotationLayer={false} />
            </Document>
        </Grid>
    );
}

export default Resume;
